import React, { useContext, useCallback } from 'react';

import { CuiIntegrationsSettings } from '../../../../connection-components/integrations-settings';
import { enums } from '../constants';
import { IntegrationsContext } from '../context';
import style from '../style.module.less';

const Settings = () => {
  const { fetchIntegrations, sellerStores } = useContext(IntegrationsContext);
  const handleQBDeletion = useCallback(() => fetchIntegrations(), [fetchIntegrations]);
  const QuickBooksAppId = enums.quickbooks;

  return (
    <div className={style['cui-container']}>
      <CuiIntegrationsSettings integrationAppId={QuickBooksAppId} onDelete={handleQBDeletion} sellerStores={sellerStores} />
    </div>
  );
};

export default Settings;
